import { apolloClient } from '@/graphql';
import gql from 'graphql-tag';

// GraphQL queries and mutations
import UpdateRedCards from '@/graphql/redcards/update/updateRedcard.gql';
import CreateRedCards from '@/graphql/redcards/create/createRedcards.gql';
import DeleteRedCards from '@/graphql/redcards/delete/deleteRedcards.gql';
import GetAllRedCards from '@/graphql/redcards/query/getRedcardsById.gql';

export default {
  state: {
    redcards: [],
  },

  getters: {
    redcards(state: any) {
      return state.redcards;
    },
  },

  mutations: {
    setRedcards(state: any, redcards: any) {
      state.redcards = redcards;
    },
  },

  actions: {
    async getRedcards({ commit }: any, player_id: any) {
      try {
        const response = await apolloClient.query({
          query: GetAllRedCards,
          variables: {player_id},
          fetchPolicy: 'no-cache',
        });

        const { data } = response;
        commit('setRedcards', data.player_red_cards);
      } catch (error) {
        console.error('Error fetching red cards:', error);
        throw error;
      }
    },

    async createRedcard({ dispatch }: any, payload: any) {
      try {
        const objects = payload.map((entry: any) => ({
          player_id: entry.player_id,
          from_date: entry.from_date,
          to_date: entry.to_date,
          reason: entry.reason,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        }));

        await apolloClient.mutate({
          mutation: CreateRedCards,
          variables: {
            objects,
          },
        });

        dispatch('getRedcards');
      } catch (error) {
        console.error('Error creating red cards:', error);
        throw error;
      }
    },

    async deleteRedcards({ dispatch }: any, id: string) {
      try {
        await apolloClient.mutate({
          mutation: DeleteRedCards,
          variables: {
            id,
          },
        });

        dispatch('getRedcards');
      } catch (error) {
        console.error('Error deleting red cards:', error);
        throw error;
      }
    },

    async updateRedcards({ dispatch }: any, payload: any) {
      try {
        const updates = payload.map((entry: any) => ({
          id: entry.id,
          player_id: entry.player_id,
          from_date: entry.from_date,
          to_date: entry.to_date,
          reason: entry.reason,
        }));
    
        // Execute the mutation for each update
        await Promise.all(updates.map((update: any) => (
          apolloClient.mutate({
            mutation: UpdateRedCards,
            variables: update,
          })
        )));
    
        // After all updates are done, dispatch an action to get the latest red cards
        dispatch('getRedcards');
      } catch (error) {
        console.error('Error updating red cards:', error);
        throw error;
      }
    },    
  },
};
